import { render } from "./PlanillaForm.vue?vue&type=template&id=350fa9f6&scoped=true"
import script from "./PlanillaForm.vue?vue&type=script&lang=js"
export * from "./PlanillaForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=350fa9f6&scoped=true&lang=css"
import "./PlanillaForm.vue?vue&type=style&index=1&id=350fa9f6&scoped=true&lang=css"
import "./PlanillaForm.vue?vue&type=style&index=2&id=350fa9f6&scoped=true&lang=css"
import "./PlanillaForm.vue?vue&type=style&index=3&id=350fa9f6&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350fa9f6"]])

export default __exports__